import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app';
import 'devextreme/dist/css/dx.light.compact.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);



